document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.getElementById('hamburger-btn');
  const mobileNav = document.getElementById('mobile-nav');
  const closeBtn  = document.getElementById('mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    function closeNav() {
      mobileNav.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    mobileNav.addEventListener('click', function (e) { if (e.target === mobileNav) closeNav(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 24px rgba(0,0,0,0.18)' : 'none';
    }, { passive: true });
  }

  const fadeEls = document.querySelectorAll('.offering-card, .stat-card, .ritual-card, .credential-card');
  if ('IntersectionObserver' in window && fadeEls.length) {
    fadeEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    });
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(function (el) { observer.observe(el); });
  }
});

/* ── Rituals accordion ── */
function raToggle(id) {
  var item = document.getElementById(id);
  if (!item) return;
  var wasOpen = item.classList.contains('ra-open');
  document.querySelectorAll('.ra-item.ra-open').forEach(function(r) {
    r.classList.remove('ra-open');
  });
  if (!wasOpen) item.classList.add('ra-open');
}
